import Controller from '../abstracts/Controller';

export default class EditorialController extends Controller {
  static get COMPONENTS() {
    let components = [
      'HeroZoomMobile',
      'HeroZoomComponent',
      'WallComponent',
      'CarouselComponent',
      'ParallaxComponent',
      'VideoComponent',
      'VideoBrightcove',
      'DominationComponent',
      'LookBookComponent',
      'CardComponent',
      'CustomPanel',
      'TogglesButtonComponent',
      'NotifyMeComponent'
    ];
    if (document.querySelector('[data-js-component="LiveChatTriggerComponent"]') != null) {
      components.push('LiveChatTriggerComponent');
    }
    return components;
  }
}
